<span class="tw-relative">
  <span [ngClass]="{ 'tw-invisible': loading }">
    <ng-content></ng-content>
  </span>
  <span
    class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center"
    [ngClass]="{ 'tw-invisible': !loading }"
  >
    <i class="bwi bwi-spinner bwi-lg bwi-spin" aria-hidden="true"></i>
  </span>
</span>
